import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, TemplateRef, ViewChild, Injectable } from '@angular/core';

import { ClientIntakeService } from '../../../services/client_intakes/client-intake.service';

import { ClientIntakeFieldService } from '../../../services/client_intakes/client-intake-field.service';

import { ContactSearchService } from '../../../services/contacts/contact-search.service';

import { NotyService } from '../../../services/common/noty.service';

declare let moment: any;

@Component({
  selector: 'app-client-intake-form',
  templateUrl: './client-intake-form.component.html',
  styleUrls: ['./client-intake-form.component.scss'],
})

export class ClientIntakeFormComponent implements OnInit, OnDestroy {

  @Output() formModalCloseEvent: EventEmitter<object> = new EventEmitter();

  constructor(
    private clientIntakeService: ClientIntakeService,
    private clientIntakeFieldService: ClientIntakeFieldService,
    public notyService: NotyService
    ) {}

  formOptions: any = {}

  clientIntakeFields: any = []

  clientIntakeFieldValues: any = []

  clientIntakeField: any = {}

  newClientIntake: any = {}

  /**
   * create params for search request
   * @type {any}
  */
  createParams: any = {
    client_intake_field_values: []
  }

  defaultAppointmentLocation: number;

  autosaveIntervalId: number | undefined;

  autoSave: boolean;

  autoSaveCount: number = 0;

  autoSaveValidity: boolean;

  componentDestroyed: boolean = false;

  matterType:any;

  miscellaneousDetails: any = []

  searchingForContacts: boolean = false;

  searchFailed: boolean;

  /**
   * Indicates if search request is being proccessed
   * @type {boolean}
   */
  submitting: boolean = false;

  /**
   * Indicates if form has been submitted atleast once
   * @type {boolean}
  */
  submitted: boolean = false;

  @Input() editingClientIntake: boolean = false;

  @Input() preFillDataForEditMode: any = {};

  @Output() editingClientIntakeStop: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    console.log("lifecycle ngOnInit() called", "preFillDataForEditMode", this.preFillDataForEditMode)
    console.log("autosaveIntervalId", this.autosaveIntervalId)
    return this.clientIntakeService.formOptions().then(formOptionsRe=>{
      if(this.componentDestroyed) return;
      console.log("form options response from backend", formOptionsRe)
      this.formOptions = formOptionsRe
      this.preFillForm();
      this.defaultAppointmentLocation = formOptionsRe.default_appointment_location.id
      this.createParams.referral_person_id = undefined;
      this.editingClientIntake ? this.createParams.autosave_disable = false : this.startAutoSave();
    }).catch(formOptionsErr=>{
      if(this.componentDestroyed) return;
      console.log("formOptionsErr", formOptionsErr)
    })
  }

  ngOnDestroy() {
    this.componentDestroyed = true;
    this.clearAutoSave();
  }

  formValididtyAutosave(){
    if(this.createParams.matter_type_id && this.createParams.rate_type_id && this.createParams.referral_type_id && this.createParams.attorney_id && this.createParams.default_appointment_address_id ){
      console.log("form is valid for autosave saving");
    }
    else{
      console.log("form is not valid for autosave saving");
    }
  }

  startAutoSave(){
    console.log("start autosave called");
    this.clearAutoSave();
    this.autoSave = true;
    this.autosaveIntervalId = window.setInterval(()=>{
      if(this.componentDestroyed) return;
      this.saveClientIntake(this.createParams.matter_type_id && this.createParams.rate_type_id && this.createParams.referral_type_id && this.createParams.attorney_id && this.createParams.default_appointment_address_id ? true : false );
    }, 30000);
  }

  clearAutoSave(){
    console.log("clear_autosave called");
    if(this.autosaveIntervalId){
      this.autoSave = false;
      window.clearInterval(this.autosaveIntervalId);
      this.autosaveIntervalId = undefined;
    }
  }

  toggleAutosave(){
    console.log("autosave_disable class variable", this.createParams.autosave_disable);
    if(this.createParams.autosave_disable){
      this.clearAutoSave();
    }else{
      this.startAutoSave();
    }
  }

  preFillForm() {
    if(this.preFillDataForEditMode && Object.keys(this.preFillDataForEditMode).length > 0 && this.editingClientIntake){
      if(this.preFillDataForEditMode.appointment_scheduled_at){
        let appointmentScheduledAt = new Date(this.preFillDataForEditMode.appointment_scheduled_at);
        this.preFillDataForEditMode.client_intake_appointment_formatted_date = {day: appointmentScheduledAt.getUTCDate(), hour: appointmentScheduledAt.getUTCHours(), minute: appointmentScheduledAt.getUTCMinutes(), month: appointmentScheduledAt.getUTCMonth(), second: appointmentScheduledAt.getUTCSeconds(), year: appointmentScheduledAt.getUTCFullYear()}
      }
      Object.assign(this.createParams, this.preFillDataForEditMode);
      console.log("this.preFillDataForEditMode from preFillForm function", this.preFillDataForEditMode)
      console.log("this.createParams from preFillForm function", this.createParams)
      this.matterType = this.createParams.matter_type_name
      this.clientIntakeFields = this.createParams.client_intake_fields || []
      const clientIntakeMiscDetails = Array.isArray(this.createParams.client_intake_misc_details) ? this.createParams.client_intake_misc_details : [];
      for(let client_intake_misc_detail of clientIntakeMiscDetails){
        for(let client_intake_misc_detail_key in client_intake_misc_detail){
          if(client_intake_misc_detail_key !== "value"){
            delete client_intake_misc_detail[client_intake_misc_detail_key]
          }
        }
      }
      this.miscellaneousDetails = clientIntakeMiscDetails
      console.log("this.miscellaneousDetails", this.miscellaneousDetails)
    }
  }

  resetForm() {
    this.createParams = {};
    this.editingClientIntake = false;
    this.editingClientIntakeStop.emit(true);
    this.submitting = false;
    this.submitted = false;
    this.clearAutoSave();
  }

  closeFormModal() {
    console.log("closeFormModal");
    this.formModalCloseEvent.emit({shouldClose: true, clientSaveSuccess: false, id: null})
    this.resetForm()
  }

  saveClientIntake(formValid: boolean) {
    if(this.componentDestroyed) return Promise.resolve();
    console.log("save client intake called");
    this.createParams.matter_type_id && this.createParams.rate_type_id && this.createParams.referral_type_id && this.createParams.attorney_id && this.createParams.default_appointment_address_id ? formValid = true : formValid = false;
    this.submitting = true;
    this.submitted = true;
    if (formValid) {
      if(this.createParams.client_intake_appointment_date)
        this.createParams.client_intake_appointment_date = moment(this.createParams.client_intake_appointment_date,'YYYY-MM-DD[T]HH:mm:ss').format('MM/DD/YYYY hh:mm a');
      const data: any = {
        appointment_scheduled_at:   this.createParams.client_intake_appointment_date,
        client_intake:              this.createParams,
        client_intake_field_values: this.getClientIntakeFieldValues(),
        client_intake_misc_details: this.miscellaneousDetails,
        id: this.createParams.id
      }
      if(this.autoSave){
        this.createParams.locked = false;
        data.autosave = this.autoSave;
      }
      else
        this.createParams.locked = true;
        console.log("client intake save data", data);
        return this.clientIntakeService.save(data).then(saveSuccess=>{
          if(this.componentDestroyed) return;
          this.submitting = false;
          this.submitted = false;
          if(this.autoSave){
            this.notyService.notify('Client Intake Autosaved', 'success');
            this.autoSaveCount++;
            this.editingClientIntake = true;
            this.createParams.id = saveSuccess.id
          }
          else{
            this.editingClientIntake ? this.notyService.notify('Client Intake updated successfully', 'success') : this.notyService.notify('Client Intake saved successfully', 'success');
            this.formModalCloseEvent.emit({shouldClose: true, clientSaveSuccess: true, id: saveSuccess.id});
            this.resetForm();
            console.log("saveSuccess", saveSuccess);
            return;
          }
      }).catch(CreateError=>{
        if(this.componentDestroyed) return;
        if(this.autoSave){
          this.notyService.notify('Client Intake Autosave failed ', 'error');
        }
        else{
          this.notyService.notify('Client Intake save failed', 'error');
        }
        console.log("CreateError", CreateError);
      })
    }
    else{
      console.log("save error block called form error");
      this.notyService.notify('Please check the form again', 'warning', 5000);
      this.submitting = false;
      return Promise.resolve();
    }
  }

  resetClientIntakeField() {
    this.clientIntakeField = {}
  }

  modifyClientIntakeFieldValues(clientIntakeField: any , actionType: string, miscDetail: string | null) {
    console.log("clientIntakeField", clientIntakeField);
    console.log("actionType", actionType);
    console.log("miscDetail", miscDetail);
    if(clientIntakeField){
      console.log("if(clientIntakeField === {})");
      if(actionType === 'add'){
        if(clientIntakeField.temp_cif_value){
          const { temp_cif_value: value, temp_cif_value_name: value_name, client_intake_field_values } = clientIntakeField
          if(value_name || value){
            for(let i in client_intake_field_values){
              if(client_intake_field_values[i].value == value){
                this.notyService.notify('"' + (value_name || value) + '" has already been added', 'error')
                return;
              }
            }
            clientIntakeField.client_intake_field_values.push({
              name:  value_name,
              value: value
            })
            this.createParams.client_intake_field_values.push({
              name:  value_name,
              value: value
            })
            if((clientIntakeField && this.createParams).hasOwnProperty('client_intake_field_values')){
              delete clientIntakeField.temp_cif_value
            }
          }
        }
      }
      else if(actionType === 'sub'){
        const index = clientIntakeField.client_intake_field_values.findIndex((fieldValue: { value: string, name: string }) => fieldValue.value === miscDetail);
        if (index !== -1) {
          clientIntakeField.client_intake_field_values.splice(index, 1);
        } else {
          this.notyService.notify(miscDetail + " does not exist", 'error');
        }
      }
    }
    else{
      if(actionType === 'add'){
        if(miscDetail){
          for(let i in this.miscellaneousDetails){
            if(this.miscellaneousDetails[i].value === miscDetail){
              this.notyService.notify(miscDetail + " has already been added", 'error')
              return;
            }
          }
          this.miscellaneousDetails.push({value: miscDetail})
          delete this.createParams.client_intake_misc_detail_temp
        }
        console.log("details array", this.miscellaneousDetails);
      }
      else if(actionType === 'sub'){
        const index = this.miscellaneousDetails.findIndex((detail: { value: string }) => detail.value === miscDetail);
        if (index !== -1) {
          this.miscellaneousDetails.splice(index, 1);
        } else {
          this.notyService.notify(miscDetail + " does not exist", 'error');
        }
      }
    }
  }

  getClientIntakeFieldValues(){
    console.log('fetching client intake field values');
    let client_intake_id           = this.createParams.id;
    let client_intake_field_values = [];
    let client_intake_fields       = this.clientIntakeFields;
    let client_intake_misc_details = this.miscellaneousDetails;
    for(let i in client_intake_fields){
      let client_intake_field = client_intake_fields[i];
      if(client_intake_field.client_intake_field_value)
        client_intake_field_values.push({
          id:                     client_intake_field.client_intake_field_value_id,
          client_intake_id:       client_intake_id,
          client_intake_field_id: client_intake_field.id,
          value:                  client_intake_field.client_intake_field_value
        });
      else{
        let cifvs = client_intake_field.client_intake_field_values;
        for(let j in cifvs){
          client_intake_field_values.push({
            id:                     cifvs[j].id,
            client_intake_id:       client_intake_id,
            client_intake_field_id: client_intake_field.id,
            value:                  cifvs[j].value
          });
        }
      }
    }
    for(let i in client_intake_misc_details){
      client_intake_field_values.push({
        id:               client_intake_misc_details[i].id,
        client_intake_id: client_intake_id,
        value:            client_intake_misc_details[i].value
      });
    }
    return client_intake_field_values;
  }

  matterTypeSelectionChange() {
    if(this.componentDestroyed) return Promise.resolve();
    const selectedMatterType = this.formOptions.matter_types.find((matterType: any) => {
      if (matterType.id == this.createParams.matter_type_id)
        return matterType;
    })
    console.log("selected matter type", selectedMatterType);
    this.matterType = selectedMatterType.name
    return this.clientIntakeFieldService.index({matter_type_id: this.createParams.matter_type_id}).then(getFieldIndexRe=>{
      if(this.componentDestroyed) return;
      console.log("getFieldIndexRe", getFieldIndexRe)
      for(let field of getFieldIndexRe){
        if(field.field_type_obj.multiple)
          field.client_intake_field_values = []
        else if(field.field_type_obj.field_linked)
          field.client_intake_field_value  = ''
        else
          field.client_intake_field_value  = ''
      }
      this.clientIntakeFields = getFieldIndexRe
    }).catch(getFieldIndexErr=>{
      if(this.componentDestroyed) return;
      console.log("getFieldIndexErr", getFieldIndexErr)
    })
  }

}
